import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { QueryParams } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

export const useGetEarnings = (filters?: QueryParams) =>
  useQuery({
    queryFn: () => api.earnings.getEarnings(filters),
    queryKey: queriesKeys.earnings.getEarnings(filters),
  })
